<template>
    <div class="carBox carBoxLeft">
        <div class="newBox">
        <div class="searchBox">

            <div class="searchGroup">
                <label>上传批次：</label>
                <el-input v-model="search_Obj.f_batch" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <div class="searchGroup">
                <label>设备编号：</label>
                <el-input v-model="search_Obj.f_device_no" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <div class="searchGroup">
                <label>设备名称：</label>
                <el-input v-model="search_Obj.f_device_name" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <div class="searchGroup">
                <label>设备IP：</label>
                <el-input v-model="search_Obj.f_device_ip" clearable @keyup.enter.native="doSearch"></el-input>
            </div>
            <div class="searchGroup">
                <label>上传状态：</label>
                <el-select v-model="search_Obj.f_upload_state" clearable placeholder="请选择" @keyup.enter.native="doSearch">
                    <el-option v-for="item in enuObj('upload_state')" :key="'upload_state'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </div>
            <div class="searchGroup">
                <label>数据时间：</label>
                <el-date-picker v-model="dateRange" type="daterange" value-format="yyyy-MM-dd" unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    @change="dateRangeSet"
                    style="width:420px">
                </el-date-picker>
            </div>
            <el-button type="primary" size="medium" icon="el-icon-search" @click.native="doSearch">搜索</el-button>
        </div>
    <el-card class="box-card">
        <div class="mainBody">
            <div class="dataBox">
                                <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                                    <el-table-column prop="batch" label="批次号" sortable="custom" min-width="120"></el-table-column>
                                    <el-table-column prop="device_no" label="设备编号" sortable="custom"></el-table-column>
                                    <el-table-column prop="user_realname" label="操作人" sortable="custom"></el-table-column>
                                    <el-table-column prop="device_ip" label="设备IP" sortable="custom"></el-table-column>
                                    <el-table-column prop="datetime" label="数据时间" sortable="custom">
                                        <template slot-scope="scope">
                                            <span>{{ formatDate1(scope.row.datetime, "yyyy-mm-dd HH:mm:ss") }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="datetime" label="上传时间" sortable="custom">
                                        <template slot-scope="scope">
                                            <span>{{ formatDate1(scope.row.upload_time, "yyyy-mm-dd HH:mm:ss") }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="upload_state" label="上传状态" sortable="custom">
                                        <template slot-scope="scope">
                                            <span>{{ transEnu(scope.row.upload_state, "upload_state") }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="操作" width="120" align="center">
                                        <template slot-scope="scope">
                                            <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick"></LabBtns>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
            <div class="pageBox">
                                <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50]" :current-page="current" :page-size="pagesize" :total="total" @current-change="pageChange" @size-change="handleSizeChange"></el-pagination>
                            </div>
        </div>
    </el-card>
</div>
        <Info
                            width="600px"
                            :id="model_id"
                            title="查看离线文件"
                            :isshow="infoshow"
                            @on-close="closeInfoDialog">
                        </Info>
    </div>
</template>

<script>
import LabBtns from "@/components/common/labbtns"
import Info from "./info"
import listutil from "@/libs/listutil"

export default {
    name: 'offLineFileList',
    mixins: [listutil],
    components: { Info, LabBtns },
    data() {
        return {
            m_name: '离线文件',
            menu_id: 2200,
            list_url: "/api/admin/offlinefile/list",
            search_Obj: {
                f_batch: '',
                f_device_no: '',
                f_device_name: '',
                f_device_ip: '',
                f_datetime_s_date: '',
                f_datetime_e_date: '',
                f_upload_state: '',
            },
            del_Obj:{
                url:'/api/admin/offlinefile/del',
                data:{
                    ids:''
                }
            },
            enu_name: ['upload_state'],
            dateRange: '',
        };
    },
    methods: {
        dateRangeSet(val){
            if(this.$isNotNull(val)){
                this.search_Obj.f_datetime_s_date = val[0]
                this.search_Obj.f_datetime_e_date = val[1]
            }else{
                this.search_Obj.f_datetime_s_date = ''
                this.search_Obj.f_datetime_e_date = ''
            }
        },
    }
};
</script>